import { createSelector } from '@reduxjs/toolkit';
import { FilterList, Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';

/**
 * Temporary State for Asset Selector filter state, as that file is in JS at the moment
 */
type TempFilterState = { filters: Record<string, unknown> };

export const selectAssetBrowserFilterSlice = (state: TempFilterState) => state.filters;

/**
 * Returns function that can be called with useSelector - used for filter value.
 */
export const selectAssetBrowserFilterValue = (filterName: Filters) =>
  createSelector(selectAssetBrowserFilterSlice, (filters) => filters[filterName] as string);

/**
 * Returns function that can be called with useSelector - used for filter dropdown options list.
 * Should be memoized on the component side to avoid unnecessary re-renders.
 */
export const selectAssetBrowserFilterOptions = <T>(filterList?: FilterList) =>
  createSelector(selectAssetBrowserFilterSlice, (filters) =>
    filterList ? (filters[filterList] as T[]) : undefined,
  );
